import { render } from "./Home.vue?vue&type=template&id=582b4fdb&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=582b4fdb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-582b4fdb"

export default script